import React, { useEffect, useState } from "react";
import NavigationContext from "./navigation-context";

export default function NavigationProvider(props) {
  const [isContacting, setIsContacting] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= 850 ? true : false
  );

  const [showImages, setShowImages] = useState({
    state: false,
    images: undefined,
    key: 0,
  });

  const navigationContext = {
    isContacting,
    isMobile,
    setIsContacting,
    setIsMobile,
    showImages,
    setShowImages,
  };

  return (
    <NavigationContext.Provider value={navigationContext}>
      {props.children}
    </NavigationContext.Provider>
  );
}
